import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import LegalPage from "@/pages/LegalPage";
import CookieBanner from "@/components/landing/CookieBanner";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

function App() {
  useEffect(() => {
    const onToast = (e) => toast.success(e.detail?.message || "Preferences saved");
    window.addEventListener("finx-toast", onToast);
    return () => window.removeEventListener("finx-toast", onToast);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/legal" element={<LegalPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#fff",
            border: "1px solid #EDE9FE",
            color: "#0F172A",
          },
        }}
      />
    </div>
  );
}

export default App;
